import renderElements from './renderElements';
export default (function () {
  var nodes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    renderBlock: renderElements(nodes, 'node')
  };
});